import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        username: null,
        checkedMenu: [],
    },
    getters: {},
    mutations: {
        setUserName(state, userName) {
            state.username = userName;
        },
        clearUser(state) {
            state.username = null;
        },
        setCheckedMenu(state, checkedMenu) {
            state.checkedMenu = checkedMenu;
        },
    },
    actions: {
        loginUser({ commit }, userName) {
            commit('setUserName', userName);
        },
        logoutUser({ commit }) {
            commit('clearUser');
        },
        loginCheckedMenu({ commit }, checkedMenu) {
            commit('setCheckedMenu', checkedMenu);
        },
    },
    plugins: [createPersistedState()],
})
